export enum ReservedSectionNames {
  Attributes = 'Attributes',
  Entities = 'Entities',
  Metadata = 'Metadata'
}

const ReservedSectionNamesTargets = {
  [ReservedSectionNames.Attributes]: 'attribute',
  [ReservedSectionNames.Entities]: 'entity',
  [ReservedSectionNames.Metadata]: 'meta'
} as const

export const isReservedSectionName = (sectionName: string): boolean =>
  sectionName && sectionName in ReservedSectionNames

export const isLockedForEditing = (sectionName: string, target: string): boolean =>
  sectionName &&
  sectionName in ReservedSectionNames &&
  sectionName in ReservedSectionNamesTargets &&
  target === ReservedSectionNamesTargets[sectionName as ReservedSectionNames]
